import { bl_sfa_deal_worklog_RowClass } from "../../../dbschema/bl_sfa_deal_worklog.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaDealWorklogContainerModel extends BaseContainerModel {
    bl_sfa_deal_worklog: bl_sfa_deal_worklog_RowClass = new bl_sfa_deal_worklog_RowClass();
}